import { useCallback, useContext } from "react";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { index as typeIndex } from "../../../repository/admTemplateEmails/TypeService";
import {
  index as headerIndex,
  show as headerShow,
  store as headerStore,
  update as headerUpdate,
  destroy as headerDestroy,
} from "../../../repository/admTemplateEmails/HeaderService";
import {
  index as footerIndex,
  show as footerShow,
  store as footerStore,
  update as footerUpdate,
  destroy as footerDestroy,
} from "../../../repository/admTemplateEmails/FooterService";
import {
  index as templateEmailIndex,
  store as templateEmailStore,
  update as templateEmailUpdate,
  destroy as templateEmailDestroy,
} from "../../../repository/admTemplateEmails/TemplateEmailService";
import { TemplateEmailsContext } from "../contexts/TemplateEmailsContext";
import { notify } from "../../../utils/notify";

export default function useTemplatesEmailsController() {
  const {
    setMainLoading,
    routine,
    setRoutine,
    header,
    headerEditor,
    setHeaderEditor,
    bodyEditor,
    setBodyEditor,
    footer,
    footerEditor,
    setFooterEditor,
    setTypesList,
    setHeadersList,
    setFootersList,
    templateDescription,
    setTemplateDescription,
    descriptionHeader,
    setDescriptionHeader,
    descriptionFooter,
    setDescriptionFooter,
    hiddenCopy,
    setHiddenCopy,
    title,
    setTitle,
    subject,
    setSubject,
    setHeaderHeandle,
    setFooterHeandle,
    headerSelected,
    setHeaderSelected,
    footerSelected,
    setFooterSelected,
    setTableEmailsItems,
  } = useContext(TemplateEmailsContext);

  const { queryParams } = useContext(QueryParamsContext);

  const initHeandleInputs = useCallback(
    async (service) => {
      try {
        setMainLoading(true);

        var callback;

        if (service === "type") {
          callback = await typeIndex(queryParams.empresa_cnpj);
          var listType = [];

          if (callback?.success) {
            callback?.data?.forEach((element) => {
              listType.push({
                label: element?.description,
                value: element?.id,
                parameters: element?.bind_parameters,
              });
            });

            setTypesList(listType);
          } else return notify("Erro ao buscar rotinas.");
        } else if (service === "header") {
          callback = await headerIndex(queryParams.empresa_cnpj);
          var listHeaders = [];

          if (callback?.success) {
            listHeaders.push({ label: "Cadastrar Novo", value: "" });
            callback?.data?.forEach((element) => {
              listHeaders.push({
                label: element?.description,
                value: element?.id,
                access:
                  element?.client_identifier &&
                  element?.client_identifier !== null
                    ? "private"
                    : "public",
              });
            });

            setHeadersList(listHeaders);
          } else return notify("Erro ao buscar cabeçalhos.");
        } else if (service === "footer") {
          callback = await footerIndex(queryParams.empresa_cnpj);
          var listFooters = [];

          if (callback?.success) {
            listFooters.push({ label: "Cadastrar Novo", value: "" });
            callback?.data?.forEach((element) => {
              listFooters.push({
                label: element.description,
                value: element.id,
                access:
                  element?.client_identifier &&
                  element?.client_identifier !== null
                    ? "private"
                    : "public",
              });
            });

            setFootersList(listFooters);
          } else return notify("Erro ao buscar rodapés.");
        } else if (service === "templatesEmails") {
          callback = await templateEmailIndex(queryParams.empresa_cnpj);

          if (callback?.success && callback?.data)
            setTableEmailsItems(callback?.data);
          else return notify("Erro ao buscar templates de emails");
        } else return notify("Erro ao carregar informações.");
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    },
    [
      setMainLoading,
      queryParams.empresa_cnpj,
      setTypesList,
      setHeadersList,
      setFootersList,
      setTableEmailsItems,
    ]
  );

  const store = async (service) => {
    try {
      setMainLoading(true);

      const body = {
        id_product: 1,
        client_identifier: queryParams.empresa_cnpj,
      };

      if (service === "headers" && header?.value === "") {
        let subBory = Object.assign(
          {
            description: descriptionHeader,
            header: btoa(headerEditor),
          },
          body
        );

        const callback = await headerStore(subBory);

        if (callback.success) {
          setHeaderSelected(callback.data?.id);
          setHeaderHeandle(atob(callback.data?.header));

          return notify("Cabeçalho criado com sucesso!", true, "success");
        } else return notify("Erro ao criar cabeçalho!");
      } else if (service === "footers" && footer?.value === "") {
        let subBory = Object.assign(
          {
            description: descriptionFooter,
            footer: btoa(footerEditor),
          },
          body
        );
        const callback = await footerStore(subBory);

        if (callback.success) {
          setFooterSelected(callback.data?.id);
          setFooterHeandle(atob(callback.data?.footer));

          return notify("Rodapé criado com sucesso!", true, "success");
        } else return notify("Erro ao criar rodapé!");
      } else if (service === "templatesEmails") {
        let subBory = Object.assign(
          {
            type_id: routine?.value,
            description: templateDescription,
            header_id: headerSelected,
            body: btoa(bodyEditor),
            footer_id: footerSelected,
            title: title,
            subject: subject,
            hidden_copy: hiddenCopy,
          },
          body
        );

        const callback = await templateEmailStore(subBory);

        if (callback.success)
          return notify(
            "Template de Email criado com sucesso!",
            true,
            "success"
          );
        else return notify("Erro ao criar Template de Email!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const show = useCallback(
    async (service) => {
      try {
        setMainLoading(true);

        if (service === "headers" && header?.value) {
          const callback = await headerShow(
            queryParams.empresa_cnpj,
            header?.value
          );

          if (callback.success && callback.data?.header) {
            setDescriptionHeader(callback.data.description || "");
            setHeaderEditor(atob(callback.data.header));
          } else return notify("Erro ao carregar cabeçalho.");
        } else if (service === "footers" && footer?.value) {
          const callback = await footerShow(
            queryParams.empresa_cnpj,
            footer?.value
          );

          if (callback.success && callback.data?.footer) {
            setDescriptionFooter(callback.data.description || "");
            setFooterEditor(atob(callback.data.footer));
          } else return notify("Erro ao carregar rodapé.");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    },
    [
      queryParams.empresa_cnpj,
      header,
      setHeaderEditor,
      setMainLoading,
      setDescriptionHeader,
      footer,
      setDescriptionFooter,
      setFooterEditor,
    ]
  );

  const update = async (service, location = null) => {
    try {
      setMainLoading(true);

      const body = {
        id_product: 1,
        client_identifier: queryParams.empresa_cnpj,
      };

      if (
        service === "headers" &&
        header?.value &&
        header?.access === "private" &&
        descriptionHeader
      ) {
        let subBory = Object.assign(
          {
            description: descriptionHeader,
            header: btoa(headerEditor),
          },
          body
        );

        const callback = await headerUpdate(subBory, header?.value);

        if (callback.success)
          return notify("Cabeçalho alterado com sucesso!", true, "success");
        else return notify("Erro ao alterar cabeçalho.");
      } else if (
        service === "footers" &&
        footer?.value &&
        footer?.access === "private" &&
        descriptionFooter
      ) {
        let subBory = Object.assign(
          {
            description: descriptionFooter,
            footer: btoa(footerEditor),
          },
          body
        );

        const callback = await footerUpdate(subBory, footer?.value);

        if (callback.success)
          return notify("Rodapé alterado com sucesso!", true, "success");
        else return notify("Erro ao alterar rodapé.");
      } else if (service === "templatesEmails" && location?.state?.item?.id) {
        let subBory = Object.assign(
          {
            type_id: routine?.value,
            description: templateDescription,
            header_id: headerSelected,
            body: btoa(bodyEditor),
            footer_id: footerSelected,
            title: title,
            subject: subject,
            hidden_copy: hiddenCopy,
          },
          body
        );

        const callback = await templateEmailUpdate(subBory);

        if (callback.success)
          return notify(
            "Template de Email alterado com sucesso!",
            true,
            "success"
          );
        else return notify("Erro ao alterar Template de Email!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const destroy = async (service, location = null) => {
    try {
      setMainLoading(true);

      const body = {
        id_product: 1,
        client_identifier: queryParams.empresa_cnpj,
      };

      if (
        service === "headers" &&
        header?.value &&
        header?.access === "private"
      ) {
        const callback = await headerDestroy(body, header.value);

        if (callback.success)
          return notify("Cabeçalho excluido com sucesso!", true, "success");
        else return notify("Erro ao deletar cabeçalho.");
      } else if (
        service === "footers" &&
        footer?.value &&
        footer?.access === "private"
      ) {
        const callback = await footerDestroy(body, footer.value);

        if (callback.success)
          return notify("Rodapé excluido com sucesso!", true, "success");
        else return notify("Erro ao deletar rodapé.");
      } else if (service === "templatesEmails" && location?.state?.item?.id) {
        const callback = await templateEmailDestroy(
          body,
          location?.state?.item?.id
        );

        if (callback.success)
          return notify(
            "Template de Email excluido com sucesso!",
            true,
            "success"
          );
        else return notify("Erro ao deletar Template de Email.");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const selectedItem = (service) => {
    try {
      if (service === "header" && header?.value) {
        setHeaderSelected(header.value);
        setHeaderHeandle(headerEditor);
      } else if (service === "footer" && footer?.value) {
        setFooterSelected(footer.value);
        setFooterHeandle(footerEditor);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const heandleTemplateEmail = useCallback(
    async (data) => {
      try {
        setMainLoading(true);

        setRoutine({
          label: data?.type?.description,
          value: data?.type?.id,
          parameters: data?.type?.bind_parameters,
        });
        setTemplateDescription(data?.description);
        setBodyEditor(atob(data?.body));
        setTitle(data?.title);
        setSubject(data?.subject);
        setHiddenCopy(data?.hidden_copy);

        if (data?.header) {
          setHeaderSelected(data.header.id || "");
          setHeaderHeandle(atob(data.header.header));
        }

        if (data?.footer) {
          setFooterSelected(data.footer.id || "");
          setFooterHeandle(atob(data.footer.footer));
        }
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    },
    [
      setMainLoading,
      setRoutine,
      setTemplateDescription,
      setBodyEditor,
      setTitle,
      setSubject,
      setHiddenCopy,
      setHeaderSelected,
      setHeaderHeandle,
      setFooterSelected,
      setFooterHeandle,
    ]
  );

  return {
    initHeandleInputs,
    store,
    show,
    update,
    destroy,
    selectedItem,
    heandleTemplateEmail,
  };
}
